import { render, staticRenderFns } from "./BetgameEditMatchdayWinner.vue?vue&type=template&id=470f3678&scoped=true"
import script from "./BetgameEditMatchdayWinner.vue?vue&type=script&lang=js"
export * from "./BetgameEditMatchdayWinner.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditMatchdayWinner.vue?vue&type=style&index=0&id=470f3678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f3678",
  null
  
)

export default component.exports